export enum RequestFlowType {
    Welcome = 'Welcome',
    WhatsNext = 'WhatsNext',
    Startup = 'Startup',
    MppTransferAmount = 'MppTransferAmount',
    MppPurchaseDecision = 'MppPurchaseDecision',
    PaymentRequestOverview = 'PaymentRequestOverview',
    PaymentMethodSelect = 'PaymentMethodSelect',
    WireInstructionsReady = 'WireInstructionsReady',
    WireInstructions = 'WireInstructions',
    HeroPackage = 'HeroPackage',
    ClientHubConfirmComplete = 'ClientHubConfirmComplete',
    ClientHubConfirmReview = 'ClientHubConfirmReview',
    ClientHubRequestBlocked = 'ClientHubRequestBlocked',
    ClientHubCollectComplete = 'ClientHubCollectComplete',
    ClientHubCollectAccountDetails = 'ClientHubCollectAccountDetails',
    ClientHubCollectReview = 'ClientHubCollectReview',
    ClientHubVerificationDocType = 'ClientHubVerificationDocType',
    ClientHubVerificationComplete = 'ClientHubVerificationComplete',
    ClientHubVerificationEnded = 'ClientHubVerificationEnded',
    ClientHubVerificationProcessing = 'ClientHubVerificationProcessing',
}